module.exports = __webpack_public_path__ + "static/teleop_arm-092fd276264e7a6c5553c3021edc1e86.jpg";